import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { RemoveFromWorkspaceDialog } from '@/features/user-management/RemoveFromWorkspaceDialog'
import { type RemoveFromWorkspaceDialogViewModel } from './RemoveFromWorkspaceDialogViewModel'

export interface RemoveFromWorkspaceDialogContainerProps {
  vm: RemoveFromWorkspaceDialogViewModel
}

export const RemoveFromWorkspaceDialogContainer = observer(
  function RemoveFromWorkspaceDialogContainer({
    vm,
  }: RemoveFromWorkspaceDialogContainerProps) {
    return (
      <RemoveFromWorkspaceDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        selectedUserName={vm.selectedUserName}
        selectedUserCount={vm.selectedUserIds.length}
        workspaceName={vm.workspace.name}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        <TextInputContainer
          autoFocus
          label="Type this word: remove"
          field="confirmation"
          model={vm}
          data-test="user-management-remove-from-workspace-remove-input"
          error={vm.validation.getError('confirmation')}
        />
      </RemoveFromWorkspaceDialog>
    )
  },
)
